import {
  Component,
  HostListener,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { ItineraryComponent } from '@sc/ui-components';
import { ScreenUtils } from '@sc/utils';
import { ItineraryInputData } from '@sc/data-access-models';

@Component({
  selector: 'sc-itinerary-bottom-sheet',
  styleUrls: ['./itinerary-bottom-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [ItineraryComponent],
  template: `
    <sc-itinerary
      [fitter]="data.fitter"
      [userLocation]="data.userAddress"
      [alt]="true"
      (closeEvent)="onCloseSheet()"
    ></sc-itinerary>
  `,
})
export class ItineraryBottomSheetComponent {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: ItineraryInputData,
    private readonly bottomSheetRef: MatBottomSheetRef<ItineraryBottomSheetComponent>
  ) {}

  onCloseSheet() {
    this.bottomSheetRef.dismiss();
  }

  @HostListener('window:resize', ['$event'])
  closeOnResize() {
    if (!ScreenUtils.isMobileResolution()) {
      this.onCloseSheet();
    }
  }
}
